import React from 'react';
import { Box } from '@mui/material';
import LandingTopBar from './LandingTopBar';
import HeroSection from './landing/sections/HeroSection';
import ThreePillarsSection from './landing/sections/ThreePillarsSection';
import ResonanceSection from './landing/sections/ResonanceSection';
import MissionSection from './landing/sections/MissionSection';
import BiocharSection from './landing/sections/BiocharSection';
import AdvisorySection from './landing/sections/AdvisorySection';
import NewsSection from './landing/sections/NewsSection';
import AboutSection from './landing/sections/AboutSection';
import Footer from './Footer';
import {
  useScrollPosition,
  useSmoothScroll,
  useSectionVisibility,
} from '../hooks';

const LandingPage = () => {
  const scrolled = useScrollPosition(50);
  const scrollToSection = useSmoothScroll(80);
  const [missionRef, missionInView] = useSectionVisibility({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100vw',
        margin: 0,
        padding: 0,
        overflowX: 'hidden',
        backgroundColor: '#FFFFFF',
      }}
    >
      <LandingTopBar scrolled={scrolled} scrollToSection={scrollToSection} />

      <HeroSection scrollToSection={scrollToSection} />

      <ThreePillarsSection scrollToSection={scrollToSection} />

      <ResonanceSection />

      <BiocharSection />

      <AdvisorySection />

      <div id="news-section">
        <NewsSection />
      </div>

      <MissionSection ref={missionRef} inView={missionInView} />

      <AboutSection />

      <div id="contact-section">
        <Footer scrollToSection={scrollToSection} />
      </div>
    </Box>
  );
};

export default LandingPage;
